var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "300px" },
            attrs: {
              "prefix-icon": "el-icon-search",
              placeholder: "Tìm tên khách hàng",
            },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.getTableData($event)
              },
            },
            model: {
              value: _vm.listQuery.search,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "search", $$v)
              },
              expression: "listQuery.search",
            },
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "140px" },
              attrs: { placeholder: "Chọn số sao" },
              on: { change: _vm.getTableData },
              model: {
                value: _vm.listQuery.star,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "star", $$v)
                },
                expression: "listQuery.star",
              },
            },
            [
              _c("el-option", { attrs: { label: "Tất cả", value: null } }),
              _vm._v(" "),
              _vm._l(5, function (star) {
                return _c("el-option", {
                  key: star,
                  attrs: { label: star + " sao", value: star },
                })
              }),
            ],
            2
          ),
          _vm._v(" "),
          _vm.showFilterArea && !_vm.$store.state.user.info.area
            ? _c(
                "el-select",
                {
                  staticClass: "filter-item",
                  staticStyle: { width: "140px" },
                  attrs: { placeholder: "Chọn khu vực" },
                  on: { change: _vm.getTableData },
                  model: {
                    value: _vm.listQuery.areaId,
                    callback: function ($$v) {
                      _vm.$set(_vm.listQuery, "areaId", $$v)
                    },
                    expression: "listQuery.areaId",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "Tất cả", value: null } }),
                  _vm._v(" "),
                  _vm._l(_vm.areas, function (area) {
                    return _c("el-option", {
                      key: area.id,
                      attrs: { label: area.name, value: area.id },
                    })
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: {
                click: function ($event) {
                  return _vm.getTableData()
                },
              },
            },
            [_vm._v("Tìm")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: { data: _vm.tableData, border: "", fit: "" },
        },
        [
          _c("el-table-column", {
            attrs: { "class-name": "text-center", type: "index", width: "50" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Khách hàng", prop: "code" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.customer
                      ? _c(
                          "ul",
                          {
                            staticStyle: {
                              "list-style": "none",
                              "padding-left": "0",
                            },
                          },
                          [
                            _c("li", [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Tên:"),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(row.customer.name))]),
                            ]),
                            _vm._v(" "),
                            row.customer.phone
                              ? _c("li", [
                                  _c("label", { attrs: { for: "" } }, [
                                    _vm._v("Số điện thoại:"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(row.customer.phone)),
                                  ]),
                                ])
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Đánh giá" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      [
                        _c("el-rate", {
                          attrs: { value: row.star, disabled: "" },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(row.comment))]),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          !_vm.storeId
            ? _c("el-table-column", {
                attrs: { label: "Cửa hàng", width: "300" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          row.store
                            ? _c("div", [
                                _c("img", {
                                  staticClass: "image",
                                  attrs: {
                                    src: _vm.$url(row.store.thumbnail),
                                    alt: "",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  {
                                    staticStyle: {
                                      "list-style": "none",
                                      "padding-left": "0",
                                    },
                                  },
                                  [
                                    _c("li", [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v("Tên:"),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(row.store.name)),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    row.store.phone
                                      ? _c("li", [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("Số điện thoại:"),
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(row.customer.phone)),
                                          ]),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  934845385
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Đơn hàng", prop: "orderCode" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.orderFood
                      ? _c("span", [_vm._v("#" + _vm._s(row.orderFood.code))])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        staticClass: "order-pagination",
        attrs: {
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getTableData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }